<template>
  <div class="post-view" v-if="currentBlog">
    <div class="container quillWrapper">
      <h2>{{ this.currentBlog[0].blogTitle }}</h2>
      <h4 class="header-time">
        Posted on:
        {{
          new Date(this.currentBlog[0].blogDate).toLocaleString("tl-PH", {
            dateStyle: "long",
          })
        }}
      </h4>
      <img class="cover-photo" :src="this.currentBlog[0].blogCoverPhoto" alt="" />
      <div
        class="post-content ql-editor"
        v-html="this.currentBlog[0].blogHTML"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewBlog",
  data() {
    return {
      currentBlog: null,
    };
  },
  async mounted() {
    this.currentBlog = await this.$store.state.blogPosts.filter((post) => {
      return post.blogID === this.$route.params.blogid;
    });
  },
};
</script>

<style scope lang="scss">
.post-view {
  min-height: 100%;
  .container {
    max-width: 1000px;
    padding: 30px 25px;
  }
  .ql-editor {
    padding: 0;
  }
  h2 {
    margin-bottom: 16px;
    font-weight: 300;
    font-size: 32px;
  }
  .cover-photo {
    width: 100%;
    margin-bottom: 0px;
  }
  .header-time {
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 24px;
  }
  .ql-video{
    width: 560px;
    height: 300px;
  }
}
</style>